import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { ApiEndpointResolver, IsEcom } from "./apiEndpointResolver";
import HttpClient from "./httpClient";
import NavigationTokensService from "./navigationTokensService";
import NavigationTokens from "../constants/navigationTokens";
import UrlService from "./urlService";

const LogoutUrlService = {
  get(): Observable<string> {
    if (IsEcom()) {
      return NavigationTokensService.get([NavigationTokens.Logout]).pipe(
        map((navTokens) => navTokens[NavigationTokens.Logout]),
      );
    }

    const redirectUrl = UrlService.getNormalizedCurrentUrl();
    let baseUri = `${ApiEndpointResolver.getLogoutUrl()}?redirectUrl=${encodeURIComponent(
      redirectUrl,
    )}`;

    return HttpClient.get({
      baseUri: baseUri,
    });
  },
};

export default LogoutUrlService;
